angular.module( 'angus.directives' ).directive( 'appServiceHistory', [
	'actionViewTemplates',
	function( actionViewTemplates ) {

		'use strict';
		
		return {
			scope: {
				closeCb    : '=',
				model      : '=actionModel',
				settings   : '=',
				widgetCode : '='
			},
			templateUrl: actionViewTemplates.serviceHistoryReportContainer
		};
	}
] );